import type { ReactNode } from "react";

/**
 * A grid cell that holds a status badge and, only when there is one, a second line (owner
 * feedback, 2026-09-28: "Can we not show Succeeded in full row? ... Same alignment behaviour in
 * other screens").
 *
 * `SkyDataGrid` gives a custom cell's direct child the full cell width, and a flex column
 * stretches its children, so a badge placed straight in a cell, or in a bare `flex-col`, drew as
 * a bar across the column. Here the badge keeps its own width (`items-start`), the cell is one
 * line unless `secondary` is given, and the grid centres it in the row (rules.md §4).
 */
export function StatusCell({
  badge,
  secondary,
  testId,
}: {
  badge: ReactNode;
  /** The live detail under the badge ("Step 1 of 3 · Extracting"); omitted, the cell is one line. */
  secondary?: ReactNode;
  testId?: string;
}) {
  return (
    <div className="flex min-w-0 flex-col items-start justify-center gap-1" data-testid={testId}>
      {badge}
      {secondary ?? null}
    </div>
  );
}
